export default __webpack_public_path__ + "alberta-sort-z-to-a.316352c666752385e7cf.svg";